export function deepExtendObject(...args) {
  var dest = args.shift();
  args.forEach(src => {
    for (let prop in src) {
      if (src[prop] && src[prop].constructor && src[prop].constructor === Object) {
        dest[prop] = dest[prop] || {};
        deepExtendObject(dest[prop], src[prop]);
      } else {
        dest[prop] = src[prop];
      }
    }
  });
  return dest;
}
